'use client'
import React from 'react'

import BottomSheet from '@/shared/components/BottomSheet'
import { Text } from '@/shared/components/typography'

type PurchaseNoticeProps = {
  isOpen: boolean
  carNum: string
  onClick: () => void
  onClose: () => void
}

const CarNumCheck = ({ isOpen, onClick, onClose, carNum }: PurchaseNoticeProps) => {
  const imgSrc = {
    src: '/icons/light_icn_notice_40.svg',
    alt: '주차번호 입력 안내',
    width: 40,
    height: 40
  }
  const bodyContent = (
    <div className="mb-[26px] mt-2 flex w-full flex-col gap-[34px] px-2">
      <Text level="text3" color="text090">
        차량번호 오기입 및 불일치로
        <br />
        인한 피해는 보상하지 않습니다.
      </Text>
      <div className="rounded-lg bg-020 px-[50px] py-[19px]">
        <Text level="title1" color="text090" weight="medium">
          {carNum}
        </Text>
      </div>
    </div>
  )
  return (
    <BottomSheet
      imgSrc={imgSrc}
      isOpen={isOpen}
      onClose={onClose}
      title="차량번호가 확실한가요?"
      className="title2"
      secondBtnText="변경"
      onSecondClick={onClose}
      bodyContent={bodyContent}
      btnText="입력완료"
      onClick={onClick}
    />
  )
}

export default CarNumCheck
